import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  DOCUMENT,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { LoaderService } from './shared/services/app-loader/loader.service';
import { AuthService } from '@auth0/auth0-angular';
import { ProjectAndPersonalDetailService } from './shared/services/client-detail/project-and-personal-detail.service';
import { DataSharingService } from './shared/services/data-sharing.service';
import {
  PushNotificationService,
  SiteVisitPushEvent,
} from './shared/services/push-notification/push-notification.service';
import { environment } from 'src/environments/environment';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { DataService } from './coordinator/data.service';
import { NotificationService } from './shared/services/notification.service';
import { EMPTY, Observable, Subscription, filter, switchMap, take, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjectService } from './shared/services/project/project.service';
import { AuthRedirectGuard } from './shared/services/auth-redirect.guard';
import {
  clearSilentSsoAttempt,
  clearStoredAuthTokens,
  getStoredAccessToken,
  getStoredIdToken,
  getUsernameFromStoredTokens,
  hasSilentSsoBeenAttempted,
  hasValidStoredSession,
  ingestCrossAppAuthTokens,
  isAuthCallbackUrl,
  isAuthSilentSsoFailure,
  isJwtExpired,
  markSilentSsoAttempted,
  stripAuthParamsFromUrl,
} from './shared/services/token.util';
import { PreviewProjectComponent } from './jan-griha-client/project/preview-project/preview-project.component';
import { MatDialog } from '@angular/material/dialog';
import { ApprovalProjectComponent } from './jan-griha-client/project/approval-project/approval-project.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewChecked, OnDestroy {
  accessTokenData = '';
  /** Router-outlet renders only after /user data is stored in DataSharingService. */
  userProfileReady = false;
  private isAuthBootstrapping = isAuthCallbackUrl();

  datas: any;
  userInfo: any;
  role: any;
  notifications: any;

  authSub?: Subscription;
  userSub?: Subscription;
  tokenSub?: Subscription;
  appStateSub?: Subscription;

  accessToken = '';
  idToken = '';
  userProfile: any;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public loaderService: LoaderService,
    public auth: AuthService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private clientService: ProjectAndPersonalDetailService,
    private pushNotificationService: PushNotificationService,
    private swPush: SwPush,
    private swUpdate: SwUpdate,
    private dataService: DataService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private dataSharingService: DataSharingService,
    private projectService: ProjectService,
    private authRedirectGuard: AuthRedirectGuard
  ) {
    if (isAuthSilentSsoFailure()) {
      stripAuthParamsFromUrl();
    }
    ingestCrossAppAuthTokens();
    this.loaderService.isLoading.next(true);

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.swUpdate.activateUpdate().then(() => {
            window.location.reload();
          });
        }
      });
    }


    // this.setupPostLoginReturnNavigation();
    // this.initializeAuthentication();
  }

  /** After Auth0 login, return user to the page they had open (appState.target). */
  // private setupPostLoginReturnNavigation(): void {
  //   this.appStateSub = this.auth.isLoading$
  //     .pipe(
  //       filter((loading) => !loading),
  //       take(1),
  //       switchMap(() => this.auth.appState$),
  //       filter((state): state is { target: string } => !!state?.target),
  //       take(1)
  //     )
  //     .subscribe((state) => {
  //       this.isAuthBootstrapping = false;
  //       this.authRedirectGuard.restoreReturnUrlAfterLogin(state.target);
  //     });
  // }

  // initializeAuthentication(): void {
  //   this.authSub = this.auth.isLoading$
  //     .pipe(
  //       filter((loading) => !loading),
  //       take(1),
  //       switchMap(() => this.auth.isAuthenticated$.pipe(take(1)))
  //     )
  //     .subscribe({
  //       next: (isAuthenticated) => {
  //         this.isAuthBootstrapping = false;

  //         if (isAuthCallbackUrl() && isAuthenticated) {
  //           const pending = peekAuthReturnUrl() || undefined;
  //           if (pending) {
  //             this.authRedirectGuard.restoreReturnUrlAfterLogin(pending);
  //           }
  //           this.loadUserAndToken();
  //           return;
  //         }

  //         if (isAuthenticated) {
  //           this.loadUserAndToken();
  //           return;
  //         }

  //         if (isAuthCallbackUrl()) {
  //           return;
  //         }

  //         this.authRedirectGuard.redirectToLogin({
  //           error: 'login_required',
  //           message: 'Not authenticated',
  //         });
  //       },
  //       error: (err) => {
  //         console.error('Auth Error:', err);
  //         this.isAuthBootstrapping = false;
  //       },
  //     });
  // }

  // loadUserAndToken(): void {
  //   this.loaderService.isLoading.next(true);

  //   if (this.authRedirectGuard.hasExpiredStoredTokens()) {
  //     clearStoredAuthTokens();
  //     this.loaderService.isLoading.next(false);
  //     this.authRedirectGuard.redirectForTokenError({
  //       error: 'login_required',
  //       message: 'Stored access or id token expired',
  //     });
  //     return;
  //   }

  //   const silentTokenOptions = {
  //     authorizationParams: {
  //       audience: environment.audience,
  //       scope: 'openid profile email',
  //     },
  //     detailedResponse: true,
  //   };

  //   this.tokenSub = this.auth
  //     .getAccessTokenSilently(silentTokenOptions as any)
  //     .pipe(
  //       catchError((error) => {
  //         if (error?.error === 'consent_required') {
  //           const cachedAccessToken = localStorage.getItem('accessToken') || '';
  //           if (cachedAccessToken && !isJwtExpired(cachedAccessToken)) {
  //             return of({ access_token: cachedAccessToken });
  //           }
  //         }
  //         return throwError(() => error);
  //       }),
  //       switchMap((tokenResponse: any) => {
  //         const accessToken =
  //           tokenResponse?.access_token ?? tokenResponse?.accessToken ?? tokenResponse;
  //         const detailedIdToken = tokenResponse?.id_token ?? '';

  //         if (!accessToken || isJwtExpired(accessToken)) {
  //           clearStoredAuthTokens();
  //           this.authRedirectGuard.redirectForTokenError({
  //             error: 'login_required',
  //             message: 'Access token expired',
  //           });
  //           return EMPTY;
  //         }

  //         this.accessTokenData = accessToken;
  //         localStorage.setItem('accessToken', accessToken);

  //         return this.auth
  //           .getAccessTokenSilently({
  //             ...silentTokenOptions,
  //             detailedResponse: true,
  //           } as any)
  //           .pipe(
  //             switchMap((freshResponse: any) => {
  //               const freshIdToken = freshResponse?.id_token ?? '';
  //               if (freshIdToken && !isJwtExpired(freshIdToken)) {
  //                 return of({ __raw: freshIdToken });
  //               }

  //               if (detailedIdToken && !isJwtExpired(detailedIdToken)) {
  //                 return of({ __raw: detailedIdToken });
  //               }

  //               return this.auth.idTokenClaims$.pipe(
  //                 take(1),
  //                 switchMap((claims) => {
  //                   const claimToken = (claims as { __raw?: string } | null)?.__raw ?? '';
  //                   if (claimToken && !isJwtExpired(claimToken)) {
  //                     return of({ __raw: claimToken });
  //                   }
  //                   return of({ __raw: '' });
  //                 })
  //               );
  //             }),
  //             catchError((idTokenError) => {
  //               console.warn('ID token silent fetch fallback triggered:', idTokenError);
  //               if (detailedIdToken && !isJwtExpired(detailedIdToken)) {
  //                 return of({ __raw: detailedIdToken });
  //               }

  //               return this.auth.idTokenClaims$.pipe(
  //                 take(1),
  //                 switchMap((claims) => {
  //                   const claimToken = (claims as { __raw?: string } | null)?.__raw ?? '';
  //                   if (claimToken && !isJwtExpired(claimToken)) {
  //                     return of({ __raw: claimToken });
  //                   }
  //                   return of({ __raw: '' });
  //                 })
  //               );
  //             })
  //           );
  //       }),
  //       tap((claims) => {
  //         const raw = claims?.__raw;
  //         if (raw && !isJwtExpired(raw)) {
  //           localStorage.setItem('idToken', raw);
  //         } else {
  //           localStorage.removeItem('idToken');
  //         }
  //       })
  //     )
  //     .subscribe({
  //       next: () => {
  //         const idToken = localStorage.getItem('idToken');
  //         if (!idToken || isJwtExpired(idToken)) {
  //           clearStoredAuthTokens();
  //           this.authRedirectGuard.redirectForTokenError({
  //             error: 'login_required',
  //             message: 'ID token expired or missing after login',
  //           });
  //           return;
  //         }
  //         this.loadUser();
  //       },
  //       error: (error) => {
  //         console.error('Token Error:', error);
  //         clearStoredAuthTokens();
  //         this.authRedirectGuard.redirectForTokenError(error);
  //         this.loaderService.isLoading.next(false);
  //       },
  //     });
  // }

  // loadUser(): void {
  //   this.userSub = this.auth.user$.pipe(take(1)).subscribe((user: any) => {
  //     const username = user?.['username'];
  //     if (!username) {
  //       return;
  //     }

  //     if (this.dataSharingService.isUserProfileLoaded()) {
  //       this.markUserProfileReady();
  //       return;
  //     }

  //     this.getUser(username);
  //   });
  // }

  private readonly authAuthorizationParams = {
    audience: environment.audience,
    redirect_uri: window.location.origin,
  };

  private currentReturnTarget(): string {
    return (
      window.location.pathname + window.location.search
    ).replace(/\/+$/, '');
  }

  private startSilentSsoLogin(): void {
    markSilentSsoAttempted();
    this.auth.loginWithRedirect({
      appState: { target: this.currentReturnTarget() },
      authorizationParams: {
        redirect_uri: window.location.origin,
        prompt: 'none',
      },
    });
  }

  private startInteractiveLogin(): void {
    clearSilentSsoAttempt();
    this.auth.loginWithRedirect({
      appState: { target: this.currentReturnTarget() },
      authorizationParams: this.authAuthorizationParams,
    });
  }

  private startSsoLogin(): void {
    if (hasSilentSsoBeenAttempted() || isAuthSilentSsoFailure()) {
      this.startInteractiveLogin();
      return;
    }

    this.startSilentSsoLogin();
  }

  private cacheStoredTokens(): void {
    const accessToken = getStoredAccessToken();
    const idToken = getStoredIdToken();

    if (accessToken) {
      this.accessToken = accessToken;
      this.accessTokenData = accessToken;
      localStorage.setItem('accessToken', accessToken);
    }

    if (idToken) {
      this.idToken = idToken;
      localStorage.setItem('idToken', idToken);
    }
  }

  private loadUserFromStoredTokens(): Observable<unknown> {
    this.cacheStoredTokens();

    const username = getUsernameFromStoredTokens();
    if (!username) {
      clearStoredAuthTokens();
      this.startSsoLogin();
      return EMPTY;
    }

    if (this.dataSharingService.isUserProfileLoaded()) {
      this.markUserProfileReady();
      return EMPTY;
    }

    return this.clientService.getUserByUsername(username);
  }

  private completeUserBootstrap(userResponse: unknown): void {
    if (!userResponse) {
      return;
    }

    const response = userResponse as any;
    this.datas = response;
    this.userInfo = response?.data?.[0];

    if (this.userInfo) {
      clearSilentSsoAttempt();
      this.populateDataSharingFromUserInfo();
      this.markUserProfileReady();
      this.requestPermission();
      this.getNotification();
    }

    this.userProfile = userResponse;
  }

  private authenticateWithAuth0(): Observable<unknown> {
    return this.auth.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.startSsoLogin();
          return EMPTY;
        }

        return this.auth.getAccessTokenSilently({
          authorizationParams: this.authAuthorizationParams,
        });
      }),
      tap((accessToken) => {
        if (!accessToken || isJwtExpired(accessToken)) {
          clearStoredAuthTokens();
          this.authRedirectGuard.redirectForTokenError({
            error: 'login_required',
            message: 'Access token expired',
          });
          return;
        }

        this.accessToken = accessToken;
        this.accessTokenData = accessToken;
        localStorage.setItem('accessToken', accessToken);
      }),
      switchMap(() => this.auth.idTokenClaims$.pipe(take(1))),
      tap((claims: any) => {
        this.idToken = claims?.__raw || '';

        if (this.idToken && !isJwtExpired(this.idToken)) {
          localStorage.setItem('idToken', this.idToken);
        } else {
          localStorage.removeItem('idToken');
        }
      }),
      switchMap(() => this.auth.user$.pipe(take(1))),
      switchMap((auth0User: any) => {
        const username =
          auth0User?.username ||
          auth0User?.nickname ||
          auth0User?.email;

        if (!username) {
          return EMPTY;
        }

        if (this.dataSharingService.isUserProfileLoaded()) {
          this.markUserProfileReady();
          return EMPTY;
        }

        return this.clientService.getUserByUsername(username);
      })
    );
  }

  private markUserProfileReady(): void {
    this.userProfileReady = true;
    this.isAuthBootstrapping = false;
    this.loaderService.isLoading.next(false);
    this.cdRef.markForCheck();
  }

  // ngOnInit(): void {

  //   this.auth.logout({
  //     logoutParams: {
  //       localOnly: true
  //     }
  //   });

  //   this.auth.loginWithRedirect();

  //   this.swPush.messages.subscribe((messages: any) => {
  //     const evt = this.pushNotificationService.parsePushMessagePayload(messages);
  //     if (evt) {
  //       this.handleSiteVisitPushEvent(evt);
  //     }
  //   });

  //   this.swPush.notificationClicks.subscribe((click) => {
  //     const evt = this.pushNotificationService.parsePushMessagePayload(
  //       click?.notification ?? click
  //     );
  //     if (evt) {
  //       this.handleSiteVisitPushEvent(evt);
  //     }
  //   });
  // }

  ngOnInit(): void {
    this.auth.appState$
      .pipe(take(1))
      .subscribe((state) => {
        if (state?.target) {
          this.router.navigateByUrl(state.target, { replaceUrl: true });
        }
      });

    this.authSub = this.auth.isLoading$
      .pipe(
        filter((loading) => !loading),
        take(1),
        switchMap(() =>
          hasValidStoredSession()
            ? this.loadUserFromStoredTokens()
            : this.authenticateWithAuth0()
        ),
        catchError((error) => {
          console.error('Auth Flow Error', error);
          clearStoredAuthTokens();
          this.authRedirectGuard.redirectForTokenError(error);
          return EMPTY;
        })
      )
      .subscribe((userResponse) => {
        this.completeUserBootstrap(userResponse);

        this.auth.appState$
          .pipe(take(1))
          .subscribe((state: any) => {
            if (state?.target) {
              this.router.navigateByUrl(state.target, { replaceUrl: true });
            }
          });
      });
  }

  // private handleSiteVisitPushEvent(evt: SiteVisitPushEvent): void {
  //   if (evt.event === 'DOWNLOAD') {
  //     this.loaderService.isLoading.next(false);
  //     if (evt.url) {
  //       this.downloadFromURL(evt.url, evt.file_name || 'download');
  //     }
  //     return;
  //   }

  //   if (evt.event === 'NOTIFICATION') {
  //     this.loaderService.isLoading.next(false);
  //     this.getNotification();
  //     return;
  //   }

  //   if (evt.event === 'PREVIEW' && evt.url) {
  //     this.loaderService.isLoading.next(false);
  //     this.openPreviewProjectDialog(evt.url);
  //     return;
  //   }

  //   if (evt.event === 'APPROVAL' && evt.url) {
  //     this.loaderService.isLoading.next(false);
  //     this.openApprovalProjectDialog(evt.url);
  //   }
  // }

  // private openPreviewProjectDialog(pdfUrl: string): void {
  //   if (
  //     this.dialog.openDialogs.some(
  //       (ref) => ref.componentInstance instanceof PreviewProjectComponent
  //     )
  //   ) {
  //     return;
  //   }
  //   this.dialog.open(PreviewProjectComponent, {
  //     width: '100vw',
  //     maxWidth: '95vw',
  //     height: '75vh',
  //     data: { pdfUrl },
  //   });
  // }

  // private openApprovalProjectDialog(pdfUrl: string): void {
  //   if (
  //     this.dialog.openDialogs.some(
  //       (ref) => ref.componentInstance instanceof ApprovalProjectComponent
  //     )
  //   ) {
  //     return;
  //   }
  //   this.dialog.open(ApprovalProjectComponent, {
  //     width: '100vw',
  //     maxWidth: '95vw',
  //     height: '75vh',
  //     data: { pdfUrl },
  //   });
  // }

  // downloadFromURL(url: string, file_name: string): void {
  //   this.projectService.downloadFile(url).subscribe({
  //     next: (data: Blob) => {
  //       const blob = new Blob([data], { type: 'application/octet-stream' });
  //       const blobUrl = window.URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = blobUrl;
  //       link.download = file_name;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       setTimeout(() => window.URL.revokeObjectURL(blobUrl), 10000);
  //       this.loaderService.isLoading.next(false);
  //     },
  //     error: (error) => {
  //       console.error('Error downloading file:', error);
  //       this.loaderService.isLoading.next(false);
  //     },
  //   });
  // }

  subscribeToPush(): void {
    this.pushNotificationService.pushSubscription();
  }

  // getUser(username: string): void {
  //   this.loaderService.isLoading.next(true);

  //   this.clientService.getUserByUsername(username).subscribe({
  //     next: (res) => {
  //       this.datas = res;
  //       this.userInfo = this.datas?.data?.[0];

  //       if (!this.userInfo) {
  //         console.error('User profile not found for username:', username);
  //         this.loaderService.isLoading.next(false);
  //         return;
  //       }

  //       this.populateDataSharingFromUserInfo();
  //       this.markUserProfileReady();

  //       this.requestPermission();
  //       this.getNotification();
  //     },
  //     error: (err) => {
  //       console.error('Failed to load user profile:', err);
  //       this.loaderService.isLoading.next(false);
  //     },
  //   });
  // }

  private populateDataSharingFromUserInfo(): void {
    this.role = this.userInfo?.role_name;
    localStorage.setItem('userInfo', this.userInfo._id);
    this.dataService.setUserId({ CoordinatorId: this.userInfo._id });
    this.dataService.setUserName({ name: this.userInfo.name });
    this.dataSharingService.clientEmail = this.userInfo?.email;
    this.dataSharingService.clientName = this.userInfo?.name;
    this.dataSharingService.setClientRole(this.userInfo?.role_name);
    this.dataSharingService.clientProfile = this.userInfo?.photoUrl;
    this.dataSharingService.clientId = this.userInfo?._id;
    this.dataSharingService.clientUserName = this.userInfo?.username;
  }

  requestPermission(): void {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (
          permission === 'granted' &&
          (this.userInfo.notify_subs === undefined || this.userInfo.notify_subs === null)
        ) {
          this.subscribeToPush();
        }
      });
    }
  }

  getNotification(): void {
    this.notificationService.fetchNotifications().subscribe({
      next: (response) => {
        this.notifications = response.data;
        this.dataSharingService.updateNotificationData(this.notifications);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.authSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.tokenSub?.unsubscribe();
    this.appStateSub?.unsubscribe();
  }
}
